export default "__VITE_ASSET__DEAyGb0e__"